import * as React from "react";
import type { SVGProps } from "react";
export const SvgValMvp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 11 11" {...props}>
    <path
      fill="currentColor"
      d="m1.909 2.844 1.64 1.093 1.635-2.289a.39.39 0 0 1 .636 0l1.635 2.29 1.64-1.094a.39.39 0 0 1 .605.37l-.642 5.457a.39.39 0 0 1-.388.345H2.334a.39.39 0 0 1-.388-.345l-.642-5.456a.39.39 0 0 1 .605-.371Z"
    />
  </svg>
);
